import * as React from 'react';
import {
  IconVKFilled16,
  IconYoutube16,
  IconTelegramFilled16,
  IconInstagramFilled16,
  IconInternet16,
} from '@cian/ui-kit';

import { ESocialType } from '../../types/builder';

interface ISocialIconProps {
  type: ESocialType;
}

export const SocialIcon: React.FC<ISocialIconProps> = ({ type }) => {
  const color = 'primary_100';

  switch (type) {
    case ESocialType.Instagram:
      return <IconInstagramFilled16 color={color} />;
    case ESocialType.Telegram:
      return <IconTelegramFilled16 color={color} />;
    case ESocialType.Vk:
      return <IconVKFilled16 color={color} />;
    case ESocialType.Youtube:
      return <IconYoutube16 color={color} />;
    default:
      return <IconInternet16 color={color} />;
  }
};
